import React from "react";
import { pointFn } from "../logic";

const AnalyzedFoodCard = ({ food, onDelete, foodIndex }) => {
  return (
    <div className="flex items-center justify-between rounded-xl bg-[#E2ECFF] py-2 pl-3 pr-2">
      <h1 className="text-black text-body2_700">
        {food.name?.length >= 9
          ? food.name.slice(0, 8) + ".."
          : food.name}
      </h1>
      <ul className="flex items-center gap-2">
        <li className="text-caption1_600 text-gray_160">
          {food.amount}
        </li>
        <li className="p-3 text-right text-white rounded-lg bg-main text-caption2_700">
          {pointFn(food.calories)} kcal
        </li>
        {onDelete && (
          <li
            onClick={() => onDelete(foodIndex)}
            className="flex items-center justify-center w-8 h-8 rounded-full bg-red-100 cursor-pointer hover:bg-red-200"
          >
            <span className="text-red-500 text-body2_700">×</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default AnalyzedFoodCard;
